/**
* 左边菜单
*/ 
<template>
  <div class="menu">
    <div class="information">
      <p class="name">服务与支持</p>
    </div>
    <div class="menus">
      <el-menu 
        :default-active="activeId" 
        class="el-menu-vertical-demo" 
        :unique-opened="true"
        active-text-color="#ff821e"
        >
        <el-menu-item v-for="item in menuList" :key="item.id" :index="item.id" @click="onForward(item.id,item.name)">
          <!-- <router-link class="router_title" :to="item.url">{{item.name}}</router-link> -->
          <p>{{item.name}}</p>
        </el-menu-item>
      </el-menu>
    </div>    
  </div>
  
</template>
<script>
export default {
  name: 'supportLeft',
  data() {
    return {
      menuList: [],
      activeId:1,
    }
  },
  props: {
    id: {
      type: String,
      default: 1,
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 在组件创建时设置默认高亮的菜单项
    this.activeId = Number(this.id);
    console.log("this.id;",this.activeId)
    // 添加路由监听器以更新高亮项
    // this.$router.afterEach((to, from) => {
    //   this.activeMenu = to.path;
    // });

    let res = {
      success: true,
      data: [
        {
          id: 1,
          name: '常见问题',
          hasThird: null,
          // url: '/support/course',
        },
        {
          id: 2,
          name: '新手指南',
          hasThird: null,
          // url: '/enroll/enroll',
        },
        // {
        //   id: 3,
        //   name: '用户手册',
        //   hasThird: null,
        //   // url: '/exam/exam',
        // }
      ],
      msg: 'success'
    }
    this.menuList = res.data
  },
  methods:{
    onForward(id,name){
      this.activeId = id;
      this.$emit('forward',id,name)
    }
  },
}
</script>
<style scoped>
.information{
  text-align: center;
  padding: 30px 0 14px;
  background-image: linear-gradient(bottom,#fff,#fff8f2);
  border: 1px solid #e2e2e4;
  border-bottom: none;
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.information img{
  width: 70px;
  margin-bottom: 4px;
}
.information .name{
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
}
.information .id{
  font-size: 12px;
  color: #949293;
  text-align: center;
}
.information .authentication{
  text-align: center;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
  line-height: 32px;
  border-bottom: 1px solid #E5E5E4;
  margin: 0 12px;
  padding-bottom: 4px;
}
.information .authentication span{
  text-align: center;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 13px;
  color: #F25902;
  cursor: pointer;
}
.menus{
  background: #fff;
  padding: 0 12px 20px; 
  border: 1px solid #e2e2e4;
  border-top: none;
  /* border-radius: 8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0; */
}
.menus ul li{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 16px 0 20px;
  cursor: pointer;
}
.menus ul li p{
  font-size: 13px;
}
.menus ul li img{
  width: 5px;
}
.menus ul .is-active{
  background: #fff2e9 !important;
}
.menus ul .is-active .router_title{
  color: #FF821E;
}
.menus .el-menu{
  border-right: none;
}
.menus .el-menu-item span{
  font-size: 13px;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-item.is-active{
  background: #fff2e9;
}
.el-menu-item:hover{
  background: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
.menus .el-menu-item{
  height: 50px;
  line-height: 50px;
}
.menus /deep/ .el-menu-item:focus{
  background: none
}
.router_title{
  font-size: 13px;
  color: #333;
  text-decoration: none;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/supportLeft.vue